import z from "zod"
import { GetCustomersSchema } from "../customers/dtos"
import { SupportSchema } from "../support/dtos"

export const ExporterBodySchema = z.union([
  z.object({
    source: z.literal("support.questions"),
    query: SupportSchema.omit({
      page: true,
      sortBy: true,
      total: true,
    }),
  }),
  z.object({
    source: z.literal("support.tickets"),
    query: SupportSchema.omit({
      page: true,
      sortBy: true,
      total: true,
    }),
  }),
  z.object({
    source: z.literal("support.entities.questions"),
    query: SupportSchema.omit({
      page: true,
      sortBy: true,
      total: true,
    }),
  }),
  z.object({
    source: z.literal("support.entities.actionRequests"),
    query: SupportSchema.omit({
      page: true,
      sortBy: true,
      total: true,
    }),
  }),
  z.object({
    source: z.literal("support.entities.issues"),
    query: SupportSchema.omit({
      page: true,
      sortBy: true,
      total: true,
    }),
  }),
  z.object({
    source: z.literal("customers"),
    query: GetCustomersSchema.omit({
      page: true,
      sortBy: true,
      total: true,
    }),
  }),
])
